import { Dropdown, Space } from 'antd';
import { DownOutlined } from '@ant-design/icons';

import { IHeaderSelectProps } from './HeaderSelect.types';

import './HeaderSelect.styles.scss';

const HeaderSelect = ({ items, onSelect, selectedKey, selectable, menu, title = '', ...props }: IHeaderSelectProps) => {
  return (
    <div className="np-header-select">
      <Dropdown
        menu={{
          items,
          selectable,
          selectedKeys: [selectedKey],
          onClick: onSelect,
          ...menu,
        }}
        trigger={['click']}
        {...props}
      >
        <Space className="np-menu__title-wrapper">
          <span className="np-header-select__title">
            {selectable ? items.find(e => e?.key === selectedKey)?.label : title}
          </span>

          <DownOutlined />
        </Space>
      </Dropdown>
    </div>
  );
};

export default HeaderSelect;
